import React from 'react';
import { AsideMenu } from '../../components/aside-menu';
import { Header } from '../../components/header';

import { Center, CenterContainer, Container } from './styles';

export const Main: React.FC = ({children}) => {
  const[state, setState] = React.useState(-1);

  const nav = () => {
    if(state === 0){
      setState(1);
      return;
    }
    if(state === 1){
      setState(0);
      return;
    }
    setState(0);
  }

  return (
    <Container>
      <Header onClickHamburger={() => {nav()}}/>
      <Center>
        <AsideMenu state={state}/>
        <CenterContainer>
          {children}
        </CenterContainer>
      </Center>
    </Container>
  )
}
